import { FormField } from 'ui/formField';
import { MESSAGING_FIELD_NAMES } from '../../constants';
import { LabelsList } from '../LabelsList';
import { ConnectedFormField } from './ConnectedFormField';
import { DescribedCheckbox } from './DescribedCheckbox';
import { FormSection } from './FormSection';

const { GROUP_RECURRING_CAMPAIGNS } = MESSAGING_FIELD_NAMES;

export const MESSAGING_SECTION_TEXT = {
  /** Section */
  sectionHeadingText: 'Messaging',
  sectionId: 'messaging',
  /** Labels */
  labelsLabelText: 'Labels',
  labelsDescriptionText: 'Manage labels, which apply to campaigns and journeys.',
  /** Group campaigns */
  groupRecurringCampaignsLabelText: 'Group recurring campaigns',
  groupRecurringCampaignsDescriptionText:
    'Group recurring campaigns underneath the parent campaign to reduce the number of campaigns shown in the Campaign Index',
};

export const MessagingFormSection = () => {
  return (
    <FormSection
      id={MESSAGING_SECTION_TEXT.sectionId}
      data-test={`${MESSAGING_SECTION_TEXT.sectionId}-form-section`}
      headingText={MESSAGING_SECTION_TEXT.sectionHeadingText}
    >
      <FormField
        labelText={MESSAGING_SECTION_TEXT.labelsLabelText}
        descriptionText={MESSAGING_SECTION_TEXT.labelsDescriptionText}
      >
        <LabelsList />
      </FormField>
      <ConnectedFormField name={GROUP_RECURRING_CAMPAIGNS}>
        <DescribedCheckbox
          DescriptionText={MESSAGING_SECTION_TEXT.groupRecurringCampaignsDescriptionText}
          label={MESSAGING_SECTION_TEXT.groupRecurringCampaignsLabelText}
          name={GROUP_RECURRING_CAMPAIGNS}
        />
      </ConnectedFormField>
    </FormSection>
  );
};
